import React from 'react';
import { AppGrid, AppGridSkeleton } from '@wix/app-market-components';
import {
  AppMarketPage,
  QueryDecorator,
  useAppsSectionSharedPropsMapper,
  useEssentials,
  useSiteContext,
  useServices,
  useUserContext,
} from '@wix/app-market-core';
import { queryDeveloperApps } from './developer-page-data';

export function DeveloperAppsSection({ appIds }: { appIds: string[] }) {
  const services = useServices();
  const { languageCode, isPremium } = useSiteContext();
  const { experiments } = useEssentials();
  const { isMobile } = useUserContext();
  const appsSectionSharedPropsMapper = useAppsSectionSharedPropsMapper();

  return (
    <QueryDecorator
      queryFn={() => queryDeveloperApps({ appIds, services })}
      queryKey={`developer-page-apps-${languageCode}-${appIds.join(',')}`}
    >
      {({ data, isLoading }) => {
        if (isLoading) {
          return (
            <AppGridSkeleton
              boxCount={Math.min(appIds.length, 12)}
              columns={4}
              minColumns={isMobile ? 1 : 4}
            />
          );
        }

        if (!data?.appGroup.apps.length) {
          return <></>;
        }

        const mappedProps = appsSectionSharedPropsMapper(
          data.appGroup,
          AppMarketPage.DEVELOPER,
          'developer-page',
          0,
        );

        return (
          <AppGrid
            apps={data.appGroup.apps}
            columns={4}
            minColumns={isMobile ? 1 : 4}
            itemMinWidth={isMobile ? '270px' : '246px'}
            languageCode={languageCode}
            isPremiumSite={isPremium}
            experiments={experiments}
            onAppClick={mappedProps.onAppClick}
            onAppLoad={mappedProps.onAppLoad}
            getHref={mappedProps.getHref}
            dataHook="developer-page-app-grid"
            showBorder={true}
          />
        );
      }}
    </QueryDecorator>
  );
}
